<template>
  <div v-if="show"
       class="active-filters"
       data-test-id="active-filters"
  >
    <template v-if="!simple">
      {{ t('marketplace_search.searched_for') }}
    </template>

    <div class="active-filters__pills">
      <div v-if="searchQuery"
           class="active-filters__bubble"
      >
        {{ searchQuery }}
        <Icon name="cross-fat-white"
              data-test-id="delete-search-searchQuery-filter"
              @click="deleteQuery"
        />
      </div>

      <div v-for="category in activeCategories"
           :key="category.id"
           class="active-filters__bubble"
      >
        {{ category.name }}
        <Icon name="cross-fat-white"
              data-test-id="delete-category-filter"
              @click="deleteCategory(category)"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from 'vue-i18n'
import Icon from '@/components/partials/Icon.vue'
import { useMarketplaceStore } from '@/stores/ssr/useMarketplaceStore'
import { storeToRefs } from "pinia"

defineProps({
  simple: Boolean,
})

const { t } = useI18n()
const marketplaceStore = useMarketplaceStore()

const { categories, searchQuery } = storeToRefs(marketplaceStore)

const activeCategories = computed(() => marketplaceStore.filteredCategories.map((id) => ({
  id,
  name: categories.value?.find((category) => category.id === id)?.name,
})))

const show = computed(() => searchQuery.value || activeCategories.value?.length)

const deleteQuery = () => {
  marketplaceStore.setSearchQuery(null)
}

const deleteCategory = async ({ id }) => {
  marketplaceStore.toggleFilteredCategory(id)
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/mixins/breakpoints-up.scss";
@import "@/assets/css/mixins/styling.scss";

.active-filters {
  display: flex;
  align-items: center;
  gap:     1rem;
  font-weight: 700;
  padding: 0 1.5rem;

  @include lg-up {
    padding: 0;
  }

  &__pills {
    display:   flex;
    gap:       0.75rem;
    align-items: center;
    flex-wrap: wrap;
  }

  &__bubble {
    color:       #ffffff;
    font-weight: 700;
    @include gradient-button;
    width:       max-content;
    padding:     0.5rem 1.25rem;
    border-radius: 9999px;
    display:     flex;
    align-items: center;
    gap:         0.5rem;

    &:deep(.b-icon-icon) {
      cursor: pointer;
    }
  }
}
</style>
